import { useMutation } from 'react-query';

import { getOnlineModeByIdAsync, updateOnlineModeAsync } from '../index';

export const useGetOnlineModeByIdAsync = () =>
  useMutation(getOnlineModeByIdAsync);

export const useUpdateOnlineModeAsync = () =>
  useMutation(updateOnlineModeAsync);
